import { render, staticRenderFns } from "./annualReportsDialog.vue?vue&type=template&id=4896098a&scoped=true"
import script from "./annualReportsDialog.vue?vue&type=script&lang=js"
export * from "./annualReportsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896098a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4896098a')) {
      api.createRecord('4896098a', component.options)
    } else {
      api.reload('4896098a', component.options)
    }
    module.hot.accept("./annualReportsDialog.vue?vue&type=template&id=4896098a&scoped=true", function () {
      api.rerender('4896098a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/annualReportsDialog.vue"
export default component.exports